'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInViewport = exports.lockScroll = exports.stringToHTML = exports.copyToClipboard = exports.objectIsEqual = exports.removeKeys = exports.getViewportSize = exports.fetchJSON = exports.getDefaultRequestConfig = exports.convertStringToCents = exports.formatMoneyFromString = exports.formatMoney = exports.range = exports.createElement = exports.capitalize = exports.arraysHaveCommonElement = exports.doesStringContainAny = exports.harmonizeElements = exports.getElements = exports.getElement = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _currency = require('@shopify/theme-currency/currency');

var shopifyCurrency = _interopRequireWildcard(_currency);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Returns the first element that is a descendant of node that
 * matches selectors.
 *
 * @param {String} selector - A DOMString containing one or more selectors to match. This string must
 *   be a valid CSS selector string
 * @param {Object} [config] - You can pass a context to scope the element selection
 * @param {HTMLElement|Document} [context=Document] - The scope we will try and find the element in
 *
 * @returns {HTMLElement} The found element or null
 */
var getElement = exports.getElement = function getElement(selector) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$context = _ref.context,
      context = _ref$context === undefined ? document : _ref$context;

  return context.querySelector(selector);
};

/**
 * Returns a list of elements that are a descendant of node that
 * matches selectors.
 *
 * @param {String} selector - A DOMString containing one or more selectors to match. This string must
 *   be a valid CSS selector string
 * @param {Object} [config] - You can pass a context to scope the element selection
 * @param {HTMLElement|Document} [context=Document] - The scope we will try and find the element in
 * @param {Boolean} [asArray=true] - Return the elements as an Array instead of an NodeList?
 *
 * @returns {Array|NodeList} The found elements or null
 */
var getElements = exports.getElements = function getElements(selector) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? document : _ref2$context,
      _ref2$asArray = _ref2.asArray,
      asArray = _ref2$asArray === undefined ? true : _ref2$asArray;

  var items = context.querySelectorAll(selector);

  return asArray ? (0, _from2.default)(items) : items;
};

/**
 * Interpretes a context and harmonizes a list of node elements by definition
 *
 * @param {HTMLElement|Document} [context=Document] - The scope we will try and find the element in
 *
 * @returns @returns {Null}
 */
var harmonizeElements = exports.harmonizeElements = function harmonizeElements() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$context = _ref3.context,
      context = _ref3$context === undefined ? document : _ref3$context;

  var types = [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)(context.querySelectorAll('[data-harmonize]'))).map(function (el) {
    return el.getAttribute('data-harmonize');
  }))));

  types.forEach(function (type) {
    switch (type) {
      case 'height':
        var biggestHeight = 0;
        context.querySelectorAll('[data-harmonize="' + type + '"]').forEach(function (el) {
          biggestHeight = el.clientHeight > biggestHeight ? el.clientHeight : biggestHeight;
        });
        context.querySelectorAll('[data-harmonize="' + type + '"]').forEach(function (el) {
          el.style.height = biggestHeight + 'px';
        });
        break;
      default:
        break;
    }
  });
};

/**
 * Checks if the passed string contains any items in an array
 *
 * @param {String} str - The string we will be searching
 * @param {Array} [items] - A list of the items we will be checking for presence in the str
 *
 * @returns {Boolean}
 */
var doesStringContainAny = exports.doesStringContainAny = function doesStringContainAny(str) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return items.some(function (i) {
    return str.includes(i);
  });
};

/**
 * Checks if elements of one array are contained in another
 *
 * @param {Array} array1 - The first array
 * @param {Array} array2 - The second array
 *
 * @returns {Boolean}
 */
var arraysHaveCommonElement = exports.arraysHaveCommonElement = function arraysHaveCommonElement(array1, array2) {
  return array1.some(function (item) {
    return array2.includes(item);
  });
};

/**
 * Capitalizes the first letter of the string
 *
 * @param {String} str - The string
 *
 * @returns {String}
 */
var capitalize = exports.capitalize = function capitalize(str) {
  return '' + str[0].toUpperCase() + str.slice(1);
};

/**
 * Creates an HTMLElement
 *
 * @param {String} tag - What type of element we want this to be
 * @param {Object} [options] - A key / value pair of properties and values we want to set on the newly
 *   created element
 *
 * @returns {HTMLElement}
 */
var createElement = exports.createElement = function createElement(tag) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var el = document.createElement(tag);

  (0, _entries2.default)(options).forEach(function (_ref4) {
    var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];

    el.setAttribute(key, value);
  });

  return el;
};

/**
 * Creates an array starting from zero with the length of the passed amount
 *
 * @param {Number} amount - How long do we want this array to be?
 *
 * @returns {Array}
 */
var range = exports.range = function range(amount) {
  return [].concat((0, _toConsumableArray3.default)(Array(amount).keys()));
};

/**
 * A wrapper around Shopify's formatMoney so we can pass the initial theme format
 *
 * @param {Number} cents - The price in cents
 * @param {String} [format] - format - shop money_format setting
 *
 * @return {String} Formatted value
 */
var formatMoney = exports.formatMoney = function formatMoney(cents) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.theme.moneyFormat;
  return shopifyCurrency.formatMoney(cents, format);
};

/**
 * Formats money when price is set as a string
 *
 * @param {String} price - The price
 *
 * @return {String} Formatted value
 */
var formatMoneyFromString = exports.formatMoneyFromString = function formatMoneyFromString(price) {
  return formatMoney(convertStringToCents(price));
};

/**
 * Converts a price string into a number in cents
 *
 * @param {String} priceStr - The price
 *
 * @return {number} Formatted value
 */
var convertStringToCents = exports.convertStringToCents = function convertStringToCents(priceStr) {
  return parseFloat(priceStr) * 100;
};

/**
 * This is the default config we will use when using fetch()
 *
 * @returns {Object}
 */
var getDefaultRequestConfig = exports.getDefaultRequestConfig = function getDefaultRequestConfig() {
  return JSON.parse((0, _stringify2.default)({
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;'
    }
  }));
};

/**
 * Default fetch boilerplate
 * @param {String} url - The URL we are looking to fetch
 * @param {Object} [config] - .fetch config to override the default
 *
 * @returns {Promise}
 */
var fetchJSON = exports.fetchJSON = function fetchJSON(url) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return fetch(url, (0, _assign2.default)({}, getDefaultRequestConfig(), config)).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
};

/**
 * This will get the viewports width and height
 *
 * @returns {Object}
 */
var getViewportSize = exports.getViewportSize = function getViewportSize() {
  return {
    vw: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
    vh: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
  };
};

/**
 * This will remove all keys from an object that are equal to value
 *
 * @returns {Object}
 */
var removeKeys = exports.removeKeys = function removeKeys(obj, value) {
  var newObj = (0, _assign2.default)({}, obj);

  (0, _keys2.default)(newObj).forEach(function (key) {
    return newObj[key] === value && delete newObj[key];
  });

  return newObj;
};

/**
 * Will check if 2 objects have the same properties
 *
 * @returns {Boolean}
 */
var objectIsEqual = exports.objectIsEqual = function objectIsEqual(obj1, obj2) {
  return (0, _stringify2.default)(obj1) === (0, _stringify2.default)(obj2);
};

/**
 * This will copy text to the clipboard
 *
 */
var copyToClipboard = exports.copyToClipboard = function copyToClipboard(text) {
  var el = createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

/**
 * Converts a string into HTML markup
 *
 * @param {string} str - HTML string
 *
 * @returns {HTMLElement}
 */
var stringToHTML = exports.stringToHTML = function stringToHTML(str) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(str, 'text/html');

  return doc.body.firstChild;
};

/**
 * Locks the body to prevent scrolling
 *
 * @param {Boolean} lock - If it should lock or unlock the body
 *
 */
var lockScroll = exports.lockScroll = function lockScroll(lock) {
  document.documentElement.classList.toggle('util-SiteOverflowed', lock);
  document.body.classList.toggle('util-SiteOverflowed', lock);
};

/**
 * Checks if a particular element is inside the viewport
 *
 * @param {HTMLElement} element - The element to check
 * @param {Number} offsetTop - Offset distance in pixels from the top
 * @param {Number} offsetBottom - Offset distance in pixels from the bottom
 *
 * @returns {Boolean}
 */
var isInViewport = exports.isInViewport = function isInViewport(element) {
  var offsetTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var offsetBottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var rect = element.getBoundingClientRect();

  return rect.bottom - offsetTop >= 0 && rect.left >= 0 && rect.top + offsetBottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};